import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { CompensationHistoryState } from './compensation-history-model';
import { dispatchGetCompensations } from './compensation-history-slice';

export function useCompensationInfo(employmentIds: number[], employeeId: number | string) {
    const dispatch = useDispatch();
    const compensationState = useSelector<TcsmStates, CompensationHistoryState>(state => state.compensationHistoryState);

	useEffect(() => {
		if (employmentIds &&
			employmentIds.length > 0 &&
			!compensationState.compensationLoaded &&
			compensationState.loadingCompensation === 0) {
            dispatchGetCompensations(dispatch, employmentIds, employeeId);
		}
    }, [employmentIds, employeeId]);


	return employmentIds &&
		compensationState.compensationLoaded &&
		compensationState.loadingCompensation === 0;
}
